import { useUser } from '#app/hooks/useUser'

interface SignedOutProps {
	children: React.ReactNode
}

export function SignedOut({ children }: SignedOutProps) {
	const { isSignedIn } = useUser()

	return !isSignedIn ? <>{children}</> : null
}
